import { Texture, TextureLoader } from 'three';

/**
 *  Loads textures from path and caches the textures.
 *  If previously loaded, return cached texture.
 */
export class TextureManager {
  private static _instance: TextureManager = new TextureManager();
  static get instance() {
    return this._instance;
  }

  private textures: Map<string, Texture> = new Map<string, Texture>();

  /**
   *  Load using callback
   */
  load(path: string, onLoad: (texture: Texture) => void) {
    if (this.textures.has(path)) {
      return onLoad(this.textures.get(path)!);
    }
    const fontLoader = new TextureLoader();
    fontLoader.load(path, (texture) => {
      this.textures.set(path, texture);
      onLoad(texture);
    });
  }

  /**
   *  Load using promises
   */
  async loadSync(path: string): Promise<Texture> {
    return new Promise((resolve, reject) => {
      if (this.textures.has(path)) {
        const texture = this.textures.get(path)!;
        return resolve(texture);
      }
      const fontLoader = new TextureLoader();
      fontLoader.load(
        path,
        (texture) => {
          this.textures.set(path, texture);
          resolve(texture);
        },
        undefined,
        reject,
      );
    });
  }

  clearCustom() {
    for (const [_, value] of Array.from(this.textures)) {
      value.dispose();
    }

    this.textures.clear();
  }
}
